import React from 'react';

import ReturnOrderShowView from '@components/shared/return_orders/ReturnOrderShowView';
import { useLoaderData, useRevalidator } from 'react-router-dom';

import { returnOrderService } from '@services/operator/returnOrderService';
import returnReceiptService from '@services/operator/returnReceiptService';

export default function ReturnOrderShow() {
  const returnOrder = useLoaderData();
  const { revalidate } = useRevalidator();

  return (
    <ReturnOrderShowView
      returnOrder={returnOrder}
      role="operator"
      returnOrderService={returnOrderService}
      returnReceiptService={returnReceiptService}
      onReopenSuccess={revalidate}
    />
  );
}
